import reducer from './reducer';

export default reducer;
export { ConsentsState } from './reducer';
export { getConsents, getUserConsents, updateUserConsent } from './actions';



// WEBPACK FOOTER //
// ./src/redux/modules/consents/index.ts